export enum ESpeedUnits {
  GBPS = 'Gbps',
  MBPS = 'Mbps',
  KBPS = 'Kbps'
}
